import { render } from "./TarjetaHome.vue?vue&type=template&id=777a0638&scoped=true"
import script from "./TarjetaHome.vue?vue&type=script&lang=js"
export * from "./TarjetaHome.vue?vue&type=script&lang=js"

import "./TarjetaHome.vue?vue&type=style&index=0&id=777a0638&scoped=true&lang=css"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-777a0638"]])

export default __exports__